(function (global, factory) {
  'use strict';
  var core = typeof module === 'object' && module.exports ? require('./events-manifest-core') : global.EventsManifestCore;
  var api = factory(core, global);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.EventsManifestRefresh = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function (core, runtime) {
  'use strict';

  var MAX_SERVER_SKEW_MS = 2 * 60 * 1000;
  var REFRESH_INTERVAL_MS = 60 * 1000;
  var BACKOFF = [5000, 10000, 20000, 40000, 60000];

  function parseHtml(source, DOMParserClass) {
    if (typeof source !== 'string' || typeof DOMParserClass !== 'function') throw new Error('manifest response is not parseable');
    var document = new DOMParserClass().parseFromString(source, 'text/html');
    var root = document.querySelector('[data-promo-events-page]');
    var node = root && root.querySelector('[data-events-manifest]');
    var epoch = root && Number(root.dataset.serverEpochMs);
    if (!root || !node || !Number.isFinite(epoch)) throw new Error('manifest response is incomplete');
    return { raw: JSON.parse(node.textContent), serverEpochMs: epoch };
  }

  function create(options) {
    options = options || {};
    var fetchFn = options.fetch || runtime.fetch;
    var DOMParserClass = options.DOMParser || runtime.DOMParser;
    var setTimeoutFn = options.setTimeout || runtime.setTimeout;
    var clearTimeoutFn = options.clearTimeout || runtime.clearTimeout;
    var monotonicNow = options.monotonicNow || function () { return runtime.performance.now(); };
    var AbortControllerClass = options.AbortController || runtime.AbortController;
    var parse = options.parseResponse || function (body) { return parseHtml(body, DOMParserClass); };
    var alive = true; var timer = null; var aborter = null; var requestRevision = 0; var failureCount = 0;
    var acceptedVersion = 0; var acceptedHash = null; var clockOrigin = null; var clockEpoch = null;

    function now() {
      return clockOrigin === null ? NaN : clockEpoch + Math.max(0, monotonicNow() - clockOrigin);
    }
    function schedule(delay) {
      if (!alive) return;
      if (timer !== null) clearTimeoutFn(timer);
      timer = setTimeoutFn(refreshNow, delay);
    }
    function fail(error) {
      if (!alive) return;
      failureCount += 1;
      if (typeof options.onFailure === 'function') options.onFailure(error, now());
      schedule(BACKOFF[Math.min(failureCount - 1, BACKOFF.length - 1)]);
    }
    function endpoint() {
      var location = options.location || runtime.location;
      var origin = location && location.origin ? location.origin : 'https://events.invalid';
      var target = new URL(options.url, origin);
      if (target.origin !== origin) throw new Error('manifest refresh endpoint must be same-origin');
      if (location && location.href) {
        var current = new URL(location.href);
        ['preview_theme_id', '_fd', 'pb'].forEach(function (key) {
          if (current.searchParams.has(key) && !target.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
        });
      }
      target.searchParams.set('_events_refresh', String(Date.now()) + '-' + requestRevision);
      return target.pathname + target.search;
    }
    function refreshNow() {
      if (!alive || typeof fetchFn !== 'function' || typeof options.url !== 'string' || !options.url) return Promise.resolve(false);
      if (timer !== null) { clearTimeoutFn(timer); timer = null; }
      requestRevision += 1;
      var revision = requestRevision;
      if (aborter) aborter.abort();
      aborter = typeof AbortControllerClass === 'function' ? new AbortControllerClass() : null;
      var url;
      try { url = endpoint(); }
      catch (error) { fail(error); return Promise.resolve(false); }
      return fetchFn(url, {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' },
        signal: aborter ? aborter.signal : undefined
      }).then(function (response) {
        if (!response || !response.ok) throw new Error('manifest refresh HTTP failure');
        var dateHeader = response.headers && response.headers.get ? response.headers.get('Date') : null;
        var headerEpoch = dateHeader ? Date.parse(dateHeader) : NaN;
        if (!Number.isFinite(headerEpoch)) throw new Error('manifest refresh lacks trusted server time');
        return response.text().then(function (body) { return { parsed: parse(body), headerEpoch: headerEpoch }; });
      }).then(function (result) {
        if (!alive || revision !== requestRevision) return false;
        if (Math.abs(result.parsed.serverEpochMs - result.headerEpoch) > MAX_SERVER_SKEW_MS) throw new Error('manifest response is stale or inconsistently timed');
        var candidateOrigin = monotonicNow();
        var existingNow = clockOrigin === null ? NaN : clockEpoch + Math.max(0, candidateOrigin - clockOrigin);
        var candidateNow = Math.max(result.parsed.serverEpochMs, result.headerEpoch, Number.isFinite(existingNow) ? existingNow : -Infinity);
        var envelope = core.readEnvelope(result.parsed.raw, options.identity, candidateNow, options.maxAgeMs);
        if (!envelope.ok) throw new Error(envelope.reason || 'manifest rejected');
        if (envelope.manifestVersion < acceptedVersion) throw new Error('manifest version regressed');
        if (envelope.manifestVersion === acceptedVersion && acceptedHash !== null && result.parsed.raw.contentHash !== acceptedHash) {
          throw new Error('manifest version changed without advancing');
        }
        clockOrigin = candidateOrigin; clockEpoch = candidateNow;
        acceptedVersion = envelope.manifestVersion; acceptedHash = result.parsed.raw.contentHash; failureCount = 0;
        if (typeof options.onAccept === 'function') options.onAccept(envelope, now);
        schedule(REFRESH_INTERVAL_MS);
        return true;
      }).catch(function (error) {
        if (!alive || revision !== requestRevision || error && error.name === 'AbortError') return false;
        fail(error); return false;
      });
    }
    function destroy() {
      if (!alive) return;
      alive = false; requestRevision += 1;
      if (timer !== null) clearTimeoutFn(timer);
      if (aborter) aborter.abort();
      timer = null; aborter = null;
    }
    schedule(0);
    return { destroy: destroy, now: now, refreshNow: refreshNow };
  }

  return { create: create, parseHtml: parseHtml };
}));
